export enum AuctionType {
  FirstPrice = 'FIRST_PRICE',
  FixedPrice = 'FIXED_PRICE',
}
